module.exports = __webpack_public_path__ + "static/media/whatsAppIcon.ba8c74a1.svg";